import React, { useRef } from 'react';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { ConfirmDialog } from 'primereact/confirmdialog';
import CustomerPriceListForm from './components/CustomerPriceListForm';
import CustomerPriceListTable from './components/CustomerPriceListTable';
import useCustomerPriceList from './hooks/useCustomerPriceList';
import CustomerPriceListFilter from './components/CustomerPriceListFilter';
import { useGetDealerAddressPriceListDropdownQuery } from '../../../../api/endpoints/priceList';
import { useLanguage } from '../../../../contexts/LanguageContext';

const CustomerPriceListPage = () => {
    const { th } = useLanguage();
    
    const { toast, tableProps, formProps, dialogVisible, handleApplyFilters, handleResetFilters, setDialogVisible, resetForm } = useCustomerPriceList();
    const { data: priceListDropdown = [] } = useGetDealerAddressPriceListDropdownQuery();

    const handleDialogHide = () => {
        resetForm();
        setDialogVisible(false);
    };
    const columnsRef = useRef(null);
    const filterFields = [
        { field: 'dealerName', headerName: th('customer.dealerName'), type: 'text' },
        { field: 'dealerAddressName', headerName: th('customer.address'), type: 'text' },
        {
            field: 'priceListId',
            headerName: th('customer.priceList'),
            type: 'select',
            options: priceListDropdown.map((p) => ({
                label: p.listName || p.name || `Liste ${p.listHeaderId}`,
                value: p.listHeaderId || p.name
            }))
        },
        {
            field: 'usageType',
            headerName: th('customerAddressPrice.usageType'),
            type: 'select',
            options: [
                { label: th('customerAddressPrice.service'), value: 1 },
                { label: th('customerAddressPrice.sales'), value: 2 }
            ]
        },
        { field: 'startDate', headerName: th('customer.contractStartDate'), type: 'date' },
        { field: 'endDate', headerName: th('customer.contractEndDate'), type: 'date' },
        { field: 'activeOnly', headerName: th('customer.status'), type: 'boolean' } //0 passive, 1 active, 2 deleted
    ];
    return (
        <div className="card">
            <Toast ref={toast} />
            <ConfirmDialog />

            <div className="flex justify-content-between align-items-center mb-4">
                <h1 className="m-0">{th('customerAddressPrice.title')}</h1>
                <Button label={th('customerAddressPrice.newPriceList')} icon="pi pi-plus" onClick={() => tableProps.handleAddNew()} />
            </div>
            <CustomerPriceListFilter filterFields={filterFields} handleApplyFilters={handleApplyFilters} priceListDropdown={priceListDropdown ?? []} handleResetFilters={handleResetFilters} />
            <CustomerPriceListForm {...formProps} visible={dialogVisible} onHide={handleDialogHide} />

            <CustomerPriceListTable {...tableProps} />
        </div>
    );
};

export default CustomerPriceListPage;
